import { type ReactNode } from 'react';
import clsx from 'clsx';

import { CheckIcon } from '@common/svg/icons/components/CheckIcon';
import { CrossIcon } from '@common/svg/icons/components/CrossIcon';
import { ErrorIcon } from '@common/svg/icons/components/ErrorIcon';
import { InfoIcon } from '@common/svg/icons/components/InfoIcon';
import { WarningIcon } from '@common/svg/icons/components/WarningIcon';

import { Button } from '../Button';
import { AlertSeverity } from './AlertSeverity';

import styles from './Alert.module.scss';

interface Props {
    severity?: AlertSeverity;
    hasIcon?: boolean;
    onClose?: () => void;
    children: ReactNode;
}

export const Alert = ({ severity = AlertSeverity.SUCCESS, hasIcon, onClose, children }: Props) => {
    const icon = () => {
        switch (severity) {
            case AlertSeverity.SUCCESS:
                return <CheckIcon className={clsx(styles['check-icon'], styles['icon'])} />;
            case AlertSeverity.ERROR:
                return <ErrorIcon className={styles['icon']} />;
            case AlertSeverity.INFO:
                return <InfoIcon className={styles['icon']} />;
            case AlertSeverity.WARN:
                return <WarningIcon className={styles['icon']} />;
        }
    };

    return (
        <div
            className={clsx(
                styles.alert,
                styles[`alert--${severity}`],
                hasIcon && styles['has-icon'],
                onClose && styles['on-close'],
            )}
        >
            {hasIcon ? icon() : null}
            {onClose ? (
                <Button className={styles['close-button']} variant={'link'} onClick={() => onClose()}>
                    <CrossIcon className={styles['cross-icon']} />
                </Button>
            ) : null}
            {children}
        </div>
    );
};
